import { useState } from "react";
import { toast } from "sonner";
import { ListChecks, Search } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const CHOICES = [
  [true, Search, "Research only", "I list on my own. I just want to know what things are worth.", "use-mode-research"],
  [false, ListChecks, "Draft & list with SnapList", "AI writes my listings and I post them to eBay and other sites.", "use-mode-full"],
];

// Asked once for new accounts; switchable later in Settings or on the Research page.
export default function UseModeChooser() {
  const { user, checkAuth } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user?.ask_use_mode) return null;
  const pick = async (on) => {
    setBusy(true);
    try { await api.put("/research-mode", { enabled: on }); await checkAuth(); }
    catch { toast.error("Couldn't save, try again"); setBusy(false); }
  };
  return (
    <Dialog open>
      <DialogContent className="max-w-md [&>button]:hidden" data-testid="use-mode-chooser" onInteractOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>How will you use SnapList?</DialogTitle>
          <DialogDescription>You can switch any time in Settings.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          {CHOICES.map(([on, Icon, title, sub, id]) => (
            <button key={id} type="button" disabled={busy} onClick={() => pick(on)} data-testid={id}
              className="flex w-full items-start gap-3 rounded-xl border border-slate-200 p-3 text-left transition-colors hover:border-[#0053DA] hover:bg-blue-50 disabled:opacity-50">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#0053DA] text-white"><Icon className="h-4 w-4" /></span>
              <span><span className="block text-sm font-semibold text-slate-900">{title}</span><span className="block text-xs text-slate-500">{sub}</span></span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
